define('drops/dynamicSlideshow/dynamicSlideshow',[
    'jquery',
    'lq/drop',
    'lq/style',
    'lq/util',
    'lq/imageSize',
    'lq',
    'underscore',
    'lq/required'
], function ($, Drop, Style, util, imageSize, lq, _, Required) {
    'use strict';

    var defaults = {
        data: {
            required: {
                initialVisibility: true,
                isRequired: false,
                valueSource: 'hardcoded'
            },
            contentHorizontalMargin: 0
        }
    };

    var movements = {
        next: 'next',
        previous: 'previous',
        none: 'none'
    };

    function DynamicSlideshow(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing) || {};

        this.inTransition = false;
        this.transitionsQueue = [];
        this.results = null;
        this.currentIndex = null;
        this.deferredUpdate = null;

        this.$element
            .addClass('boxToBorderSize dynamic-slideshow');

        this.$imageWrapper = $('<div class="dynamic-slideshow-image" />')
            .css({
                marginLeft: this.data.contentHorizontalMargin + 'px',
                marginRight: this.data.contentHorizontalMargin + 'px'
            })
            .appendTo(this.$element);

        this._addPanels();

        Style.renderStyles(this, null, this.$imageWrapper);
    };

    Drop.extend(DynamicSlideshow, Drop);

    DynamicSlideshow.typeName = 'DynamicSlideshow';

    DynamicSlideshow.prototype.preRender = function () {
        var self = this;
        this.piping.visibility.apply(this);
        this.piping.required.apply(this);
        this.piping.datasources.registerDatasourceListener(
            this.data.dataSource,
            function(data) {
                 self.update(data);
            });

        this.formatter = this.piping.formatting.createFormatter(this.data.formatting);
        this.applyPosition();
    };

    DynamicSlideshow.prototype.startAutoSlide = function() {
        if (!this.data.autoTransition) return;
        this.cancelAutoSlide();
        this.autoTransitionTimer = _.delay(this._next.bind(this, this), this.data.transitionDelay * 1000);
    };

    DynamicSlideshow.prototype.cancelAutoSlide = function () {
        if (this.data.autoTransition)
            clearTimeout(this.autoTransitionTimer);
    };

    DynamicSlideshow.prototype.update = function (update) {
        this.cancelAutoSlide();

        var previousResults = this.results;
        this.results = update.results;

        if (this.results.length > 0) {
            if (this.deferredUpdate) {
                this.setValue(this.deferredUpdate);
                this.deferredUpdate = null;
                return;
            }

            if (this.currentIndex != null) {
                if (previousResults.length > 0) {
                    var keyOfCurrentImage = previousResults[this.currentIndex][this.data.selectedKeyField];
                    var index = this.getIndexOfRowWithKey(keyOfCurrentImage);

                    if (index !== null)
                        this._setImage(index, false, movements.none);
                    else
                        this._setImage(0, true, movements.none);
                } else {
                    this.currentIndex = null;
                }
            } else {
                this._setImage(0, true, movements.none);
            }
        }
    };

    DynamicSlideshow.prototype._next = function () {
        if (!this.results || this.results.length === 0)
            return;

        var nextIndex = this.currentIndex + 1;
        if (this.results[nextIndex]) {
            this._setImage(nextIndex, true, movements.next);
        } else {
            this._setImage(0, true, movements.next);
        }
    };

    DynamicSlideshow.prototype._previous = function () {
        if (!this.results || this.results.length === 0)
            return;

        var previousIndex = this.currentIndex - 1;
        if (this.results[previousIndex]) {
            this._setImage(previousIndex, true, movements.previous);
        } else {
            this._setImage(this.results.length - 1, true, movements.previous);
        }
    };

    DynamicSlideshow.prototype._setImage = function (index, withEvent, movement) {
        var self = this;
        self.inTransition = true;
        self.currentIndex = index;
        var value = util.convertListOfKeyValuesToObject(self.results[index][self.data.selectedDocumentField]);
        if (!value) {
            return;
        }
        var url = value.url || value.Url;
        if (url.length !== 0) {
            var imageTypes = ['png', 'jpg', 'gif', 'tiff', 'jpeg', 'bmp', 'pdf'];
            var extension = url.substr(url.lastIndexOf('.') + 1, url.length - url.lastIndexOf('.')).toLowerCase();

            var filePath = lq.getTenantUrl('DynamicContent/File/' + url);

            if (imageTypes.indexOf(extension) === -1) {
                filePath = lq.getTenantUrl('DynamicContent/Icon/' + url);
            } else if (self.data.useThumbnail) {
                var requiredSize = imageSize.forElement(self.data.size);
                filePath = lq.getTenantUrl('DynamicContent/Thumbnail/' + url + '?width=' + requiredSize.x + '&height=' + requiredSize.y + '&filetype=png&isMaxSize=true');
            }

            // prefetch the image and wait until it's actually loaded
            $('<img/>').attr('src', filePath).on('load', function () {
                $(this).remove();

                var $image = $('<div class="dynamic-slideshow-image" />')
                    .attr('title', self.data.title);

                if (self.data.selectedResizeOption === 'Stretch Image')
                    $image.css('background-size', '100% 100%');
                else if (self.data.selectedResizeOption === 'Keep Ratio, Show Complete Image')
                    $image.css({
                        'background-size': 'contain',
                        'background-repeat': 'no-repeat',
                        'background-position': 'center'
                    });
                else if (self.data.selectedResizeOption === 'No-Resize')
                    $image.css({
                        // When generating a thumbnail for high resolution devices we have to generate an image that has
                        // twice the width and twice the height as the drop. In that case we can't set the size to 'auto'
                        // because that would give the image twice its size in the browser
                        'background-size': self.data.useThumbnail && imageSize.hasHighPixelRatio() ? 'contain' : 'auto',
                        'background-repeat': 'no-repeat',
                        'background-position': 'center'
                    });

                $image.css('background-image', 'url(' + filePath + ')');

                var $previous = self.$imageWrapper.children();

                var hideAnimation = self.getHideAnimation(movement);
                if (hideAnimation && hideAnimation !== "none") {
                    $previous.addClass('animated ' + hideAnimation);
                    $previous.one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend',
                        function() {
                            $previous.remove();
                        });
                } else {
                    $previous.remove();
                }

                self.$imageWrapper
                    .prepend($image);

                var showAnimation = self.getShowAnimation(movement);
                if (showAnimation && showAnimation !== "none") {
                    $image.addClass('animated ' + showAnimation);
                    $image.one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend',
                        function() {
                            $image.removeClass('animated ' + showAnimation);
                            self.inTransition = false;
                            self.runNextInQueue();
                        });
                } else {
                    self.inTransition = false;
                    self.runNextInQueue();
                }

                if (withEvent === true) {
                    if (self.isEventEnabled('displayed')) {
                        var arg = self.data.selectedKeyField ? self.results[index][self.data.selectedKeyField] : null;
                        self.triggerEvent(self.data.eventing.displayed.raisedEventName, arg);
                    }
                }

                self.startAutoSlide();
            });
        }
    };

    DynamicSlideshow.prototype.getShowAnimation = function(movement) {
        if (movement === movements.next)
            return this.data.nextShowAnimation;
        if (movement === movements.previous)
            return this.data.previousShowAnimation;
        return null;
    };

    DynamicSlideshow.prototype.getHideAnimation = function (movement) {
        if (movement === movements.next)
            return this.data.nextHideAnimation;
        if (movement === movements.previous)
            return this.data.previousHideAnimation;
        return null;
    };

    DynamicSlideshow.prototype.getLeftImage = function() {
        return this.data.leftButtonImage
            ? lq.getTenantUploads(this.data.leftButtonImage)
            : lq.getCdnUrl('drops/dynamicSlideshow/left-arrow.png');
    };

    DynamicSlideshow.prototype.getRightImage = function () {
        return this.data.rightButtonImage
            ? lq.getTenantUploads(this.data.rightButtonImage)
            : lq.getCdnUrl('drops/dynamicSlideshow/right-arrow.png');
    };

    DynamicSlideshow.prototype._addPanels = function () {
        var self = this;

        self.$leftArrow = $('<div />')
            .css({
                backgroundImage: 'url(' + this.getLeftImage() + ')',
                width: '33%',
                height: '100%',
                float: 'left',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'left 10px center',
                position: 'relative',
                zIndex: '3',
                opacity: '0.6'
            })
            .attr('unselectable', 'on')
            .on('mouseenter', function () {
                $(this).css({
                    opacity: '1'
                });
            })
            .on('mouseleave', function () {
                $(this).css({
                    opacity: '0.6'
                });
            })
            .on('click', function () {
                self.queue(function () {
                    self._previous();
                });
            })
            .appendTo(self.$element);

        var $centerclick = $('<div />')
            .css({
                width: '34%',
                height: '100%',
                'float': 'left',
                position: 'relative',
                zIndex: '3'
            })
            .attr('unselectable', 'on')
            .appendTo(self.$element);

        if (self.data.eventing.selected && self.data.eventing.selected.enabled === true) {
            $centerclick
                .on('click', function () {
                    if (!self.piping) return;
                    var arg = self.data.selectedKeyField && self.results ? self.results[self.currentIndex][self.data.selectedKeyField] : null;
                    self.piping.eventing.publish(self.data.eventing.selected.raisedEventName, self.$element, arg);
                });
        }

        self.$rightArrow = $('<div />')
            .css({
                backgroundImage: 'url(' + this.getRightImage() + ')',
                width: '33%',
                height: '100%',
                float: 'left',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right 10px center',
                position: 'relative',
                zIndex: '3',
                opacity: '0.6'
            })
            .attr('unselectable', 'on')
            .on('mouseenter', function () {
                $(this).css({
                    opacity: '1'
                });
            })
            .on('mouseleave', function () {
                $(this).css({
                    opacity: '0.6'
                });
            })
            .on('click', function () {
                self.queue(function() {
                    self._next();
                });
            })
            .appendTo(self.$element);
    };

    DynamicSlideshow.prototype.queue = function (callback) {
        if (this.inTransition) {
            this.transitionsQueue.push(callback);
        } else {
            callback();
        }
    };

    DynamicSlideshow.prototype.runNextInQueue = function () {
        if (this.transitionsQueue.length === 0) return;
        var callback = this.transitionsQueue.shift();
        callback();
    };

    DynamicSlideshow.prototype.getValue = function () {
        if (this.data.selectedKeyField && this.currentIndex) {
            return this.results[this.currentIndex][this.data.selectedKeyField];
        }

        return undefined;
    };

    DynamicSlideshow.prototype.clearValue = function () {
        if (this.results.length > 0) {
            this._setImage(0, true, movements.none);
        }
    };

    DynamicSlideshow.prototype.setValue = function (update) {
        if (update.value && this.data.selectedKeyField) {
            if (this.results) {
                var index = this.getIndexOfRowWithKey(update.value);
                if (index !== null) {
                    this._setImage(index, true, movements.none);
                }
            } else {
                this.deferredUpdate = update;
            }
        }
    };

    DynamicSlideshow.prototype.getIndexOfRowWithKey = function(key) {
        for (var i = 0; i < this.results.length; i++) {
            var rowId = this.results[i][this.data.selectedKeyField];
            if (rowId === key) {
                return i;
            }
        }

        return null;
    };

    return DynamicSlideshow;
});
